var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.06 3.856 2.806 2.706 1.046-1.11L13.292 1 8.818 5.458l1.066 1.091 2.66-2.65v5.94H1.378V25h23.96l.04-15.16H14.06V3.855Zm-.178-.17-.57-.55-.552.55h1.123ZM2.902 11.378h9.643v8.296h1.516v-8.296h9.803l-.033 12.088H2.9V11.38Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UploadFilled.2a2a4bc41c6075290f636602abc797b0.svg";